import React from 'react';
import { Phone, MapPin, Menu } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onNavigate }) => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <img 
          src="https://customer-assets.emergentagent.com/job_masigo-chapel/artifacts/4q72sfug_masigologo.png" 
          alt="Masigo" 
          className="hero-logo"
        />
        <p className="hero-subtitle">Authentic Korean Dining in Chapel Market</p>
        <p className="hero-tagline">Warm flavours. Generous portions. True Korean tradition.</p>
        
        <div className="hero-buttons">
          <Button 
            size="lg" 
            className="hero-button hero-button-primary"
            onClick={() => onNavigate('menu')}
          >
            <Menu className="w-5 h-5" />
            View Menu
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="hero-button hero-button-outline"
            onClick={() => window.location.href = 'tel:+442079163212'}
          >
            <Phone className="w-5 h-5" />
            Book a Table
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="hero-button hero-button-outline"
            onClick={() => onNavigate('contact')}
          >
            <MapPin className="w-5 h-5" />
            Get Directions
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
